import React, {Component} from 'react';
import { Dropdown, Icon } from 'semantic-ui-react';
import style from './UserDropdown.scss';

class UserDropdown extends Component {
    constructor(props) {
        super();
        this.state = {
            user: JSON.parse(props.user),
            token: props.token
        };
        this.signOutHandler = this.signOutHandler.bind(this);
        this.checkProfileHandler = this.checkProfileHandler.bind(this);
    }

    signOutHandler(){
        localStorage.clear();
        window.location = `${process.env.PUBLIC_URL}/`;
    }
    checkProfileHandler(){
        window.location = `${process.env.PUBLIC_URL}/users/profile`;
    }

    render() {
        //user drop down
        const trigger = (
            <span>
                <Icon name='user'/><span className="user-text"> Hello, {this.state.user.username}</span>
            </span>
        );
        const options = [
            {
                key: 'user',
                text: (
                    <span>
                Signed in with <strong>{this.state.user.email}</strong>
            </span>
                ),
                disabled: true,
            },
            { key: 'profile', text: 'Your Profile', onClick:this.checkProfileHandler},
            { key: 'sign-out', text: 'Sign Out', onClick:this.signOutHandler},
        ];

        return (
            <Dropdown className="UserDropdown" trigger={trigger} options={options}/>
        );
    }
}

export default UserDropdown;